import { Helmet } from 'react-helmet-async';

// Add this component inside your Home.jsx
const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ElectricalContractor",
    "name": "Tayyab Electric Studio",
    "alternateName": "TES",
    "description": "Professional electrical installation, CCTV, smart home automation, solar power, and security systems in Baramulla, Kashmir. 13+ years experience.",
    "url": "https://arstc.netlify.app",
    "telephone": "+91-99066-69918",
    "email": "tayyabelectricstudio@outlook.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Kralpora-Fatehgarh",
      "addressLocality": "Baramulla",
      "addressRegion": "Jammu & Kashmir",
      "postalCode": "193101",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "34.2268",
      "longitude": "74.3401"
    },
    "openingHoursSpecification": [
      { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"], "opens": "09:00", "closes": "20:00" },
      { "@type": "OpeningHoursSpecification", "dayOfWeek": "Sunday", "opens": "10:00", "closes": "18:00" }
    ],
    "priceRange": "₹₹",
    "currenciesAccepted": "INR",
    "paymentAccepted": "Cash, UPI, Bank Transfer",
    "areaServed": ["Baramulla", "Sopore", "Pattan", "Rafiabad", "Uri", "Tangmarg", "Boniyar"],
    "serviceType": ["Electrical Installation", "CCTV Installation", "Smart Home Automation", "Solar Power", "Security Systems", "Annual Maintenance"],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Electrical Services",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Electrical Installation" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "CCTV Systems" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Smart Home Automation" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Solar Power Installation" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Annual Maintenance Contract" } }
      ]
    },
    "sameAs": [
      "https://www.facebook.com/tayyabelectricstudio",
      "https://www.instagram.com/tayyabelectricstudio",
      "https://www.youtube.com/@TAYYABELECTRICSTUDIO"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
